module.exports = __webpack_public_path__ + "img/jrbj.e7c68117.png";